<div class="atm" (click)="cancel()">
  <div class="atm__panel" (click)="$event.stopPropagation()">

    <header class="atm__head">
      <h2>
        <i class="fa-solid fa-clipboard-check"></i>
        {{ 'ASSIGNMENTS.FORM.TITLE' | translate }}
      </h2>
      <button class="atm__close" type="button" (click)="cancel()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </header>

    <div class="atm__body">

      <p class="atm__test" *ngIf="testTitle">
        <i class="fa-solid fa-file-lines"></i>
        <strong>{{ testTitle }}</strong>
      </p>

      <!-- Target type chooser -->
      <div class="atm__section">
        <label class="atm__label">{{ 'ASSIGNMENTS.FORM.TARGET_TYPE' | translate }}</label>
        <div class="atm__targets">
          <button class="atm__target" type="button"
                  [class.is-active]="target() === 'group'"
                  (click)="setTarget('group')">
            <i class="fa-solid fa-users"></i>
            <span>{{ 'ASSIGNMENTS.FORM.TARGET_GROUP' | translate }}</span>
          </button>
          <button class="atm__target" type="button"
                  [class.is-active]="target() === 'student'"
                  (click)="setTarget('student')">
            <i class="fa-solid fa-user-graduate"></i>
            <span>{{ 'ASSIGNMENTS.FORM.TARGET_STUDENT' | translate }}</span>
          </button>
          <button class="atm__target" type="button"
                  [class.is-active]="target() === 'subject'"
                  [disabled]="!subjectId"
                  (click)="setTarget('subject')">
            <i class="fa-solid fa-book"></i>
            <span>{{ 'ASSIGNMENTS.FORM.TARGET_SUBJECT' | translate }}</span>
          </button>
        </div>
      </div>

      <!-- Group picker -->
      <div class="atm__section" *ngIf="target() === 'group'">
        <label class="atm__label">{{ 'ASSIGNMENTS.FORM.PICK_GROUP' | translate }}</label>

        <!-- Erreur de chargement : jamais de données de substitution -->
        <app-error-state *ngIf="!groupsLoading() && groupsErrored()"
                         titleKey="ASSIGNMENTS.FORM.ERROR_TITLE"
                         messageKey="ASSIGNMENTS.FORM.ERROR_DESC"
                         (retry)="reloadGroups()"></app-error-state>

        <select class="atm__select"
                *ngIf="!groupsErrored()"
                [value]="groupId() ?? ''"
                (change)="groupId.set(+$any($event.target).value || null)">
          <option value="" disabled>{{ 'ASSIGNMENTS.FORM.SELECT_GROUP' | translate }}</option>
          <option *ngFor="let g of groups()" [value]="g.id">
            {{ g.name }}
            <ng-container *ngIf="g.memberCount != null"> · {{ g.memberCount }}</ng-container>
          </option>
        </select>
      </div>

      <!-- Student picker (search + list) -->
      <div class="atm__section" *ngIf="target() === 'student'">
        <label class="atm__label">{{ 'ASSIGNMENTS.FORM.PICK_STUDENT' | translate }}</label>

        <!-- Erreur de chargement : jamais de données de substitution -->
        <app-error-state *ngIf="!studentsLoading() && studentsErrored()"
                         titleKey="ASSIGNMENTS.FORM.ERROR_TITLE"
                         messageKey="ASSIGNMENTS.FORM.ERROR_DESC"
                         (retry)="reloadStudents()"></app-error-state>

        <ng-container *ngIf="!studentsErrored()">
        <div class="atm__search">
          <i class="fa-solid fa-magnifying-glass"></i>
          <input type="search"
                 [value]="studentQuery()"
                 (input)="studentQuery.set($any($event.target).value)"
                 [placeholder]="'ASSIGNMENTS.FORM.SEARCH_STUDENT' | translate">
        </div>
        <ul class="atm__students">
          <li *ngFor="let s of filteredStudents()"
              class="atm__student"
              [class.is-active]="studentId() === s.id"
              (click)="pickStudent(s.id)">
            <div class="atm__student-avatar">
              {{ s.fullName.charAt(0).toUpperCase() }}
            </div>
            <div class="atm__student-main">
              <div class="atm__student-name">{{ s.fullName }}</div>
              <div class="atm__student-code" *ngIf="s.code">{{ s.code }}</div>
            </div>
            <i class="fa-solid fa-circle-check atm__student-tick" *ngIf="studentId() === s.id"></i>
          </li>
          <li *ngIf="filteredStudents().length === 0" class="atm__students-empty">
            {{ 'ASSIGNMENTS.FORM.NO_STUDENTS' | translate }}
          </li>
        </ul>
        </ng-container>
      </div>

      <!-- Subject (read-only) -->
      <div class="atm__section" *ngIf="target() === 'subject'">
        <label class="atm__label">{{ 'ASSIGNMENTS.FORM.PICK_SUBJECT' | translate }}</label>
        <div class="atm__readonly">
          <i class="fa-solid fa-book"></i>
          <strong>{{ subjectName ?? ('ASSIGNMENTS.FORM.UNKNOWN_SUBJECT' | translate) }}</strong>
          <span class="atm__hint">{{ 'ASSIGNMENTS.FORM.SUBJECT_NOTE' | translate }}</span>
        </div>
      </div>

      <!-- Instructions -->
      <div class="atm__section">
        <label class="atm__label" for="atm-instr">
          {{ 'ASSIGNMENTS.FORM.INSTRUCTIONS' | translate }}
          <span class="atm__optional">— {{ 'ASSIGNMENTS.FORM.OPTIONAL' | translate }}</span>
        </label>
        <textarea id="atm-instr" maxlength="1000" rows="3" class="atm__textarea"
                  [value]="instructions()"
                  (input)="instructions.set($any($event.target).value)"
                  [placeholder]="'ASSIGNMENTS.FORM.INSTRUCTIONS_PLACEHOLDER' | translate"></textarea>
      </div>

      <!-- Due date -->
      <div class="atm__section">
        <label class="atm__label" for="atm-due">
          {{ 'ASSIGNMENTS.FORM.DUE_DATE' | translate }}
          <span class="atm__optional">— {{ 'ASSIGNMENTS.FORM.OPTIONAL' | translate }}</span>
        </label>
        <input id="atm-due" type="date" class="atm__input"
               [value]="dueDate()"
               (input)="dueDate.set($any($event.target).value)">
      </div>

    </div>

    <footer class="atm__actions">
      <button type="button" class="atm__btn atm__btn--ghost"
              (click)="cancel()" [disabled]="submitting()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button type="button" class="atm__btn atm__btn--primary"
              (click)="submit()" [disabled]="!canSubmit()">
        <i class="fa-solid fa-check" *ngIf="!submitting()"></i>
        <i class="fa-solid fa-spinner fa-spin" *ngIf="submitting()"></i>
        {{ 'ASSIGNMENTS.FORM.CREATE_DRAFT' | translate }}
      </button>
    </footer>

  </div>
</div>
